import {CrudAction, dispatchAfterFilterEpic, executeCrudEpic, Type} from 'lib/crud'
import {name} from 'lib/studentTeacher'
import {State} from 'lib/store'
import {dao} from 'lib/users'
import {combineEpics} from 'redux-observable'

export const studentTeachersEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),

    dispatchAfterFilterEpic(name, (action, state: State) => CrudAction.execute(name, Type.LIST, {
        orderName: state.studentTeachers.crud.listOptions.sortDirection,
        page: state.studentTeachers.crud.listOptions.page + 1,
        itemsPerPage: state.studentTeachers.crud.listOptions.pageSize,
        ...state.studentTeachers.crud.filters
    }))
)